export default __webpack_public_path__ + "i18n/translations/translation-ar.8c82face.json";